<template lang="pug">
.checklist-form-pages-item
  .checklist-form-pages-item__header
    .checklist-form-pages-item__number {{ `${checkliststLocales.page} № ${pageOrder}` }}
  .checklist-form-pages-item__title
    string-field.checklist-form-pages-item__title-field(
      v-model="pageTitle",
      @change="changePageValue",
      :initialValue="pageTitle",
      :required="true",
      :invalid="Boolean(errors.title)",
      :errorMessage="notifies.not_empty",
      :label="checkliststLocales.page_title",
      :placeholder="checkliststLocales.enter_page_title"
    )
  .checklist-form-pages-item__fields
    checklistField(
      v-for="field in sortedFields",
      :id="getFieldAnchorId(field.order)",
      :key="field.uid",
      :field="field",
      :errors="getFieldErrors(field.uid)",
      @change-field="val => changeFieldValue(field.uid, val)"
    )
  button.checklist-form-pages-item__add-field-button(type="button", @click="addField")
    span {{ checkliststLocales.to_add_field }}
    q-icon(name="add")
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import { handleError } from "@/services/handleErrors";
import checklistField from "./checklistField.vue";
import stringField from "../../../shared/general_components/fields/stringField.vue";
import { checkliststLocales, notifies } from "@/services/useLocales";

const props = defineProps({
  /** Проп текущей страницы. Хранит в поля и title страницы */
  page: { type: Object, default: () => {} },
  /** Фронтовый uid страницы чеклиста. */
  pageUid: { type: String, default: () => "" },
  /** Порядковый номер страницы чеклиста. */
  pageOrder: { type: Number, default: () => 1 },
  /** Ошибки валидации текущей страницы и её полей. */
  errors: { type: Object, default: () => ({}) },
});

const emit = defineEmits([
  /** Эмит для обновления данных страницы */
  "change-page",
  /** Эмит для добавления поля в страницу */
  "add-field",
  /** Эмит для обновления поля страницы */
  "change-field",
]);

const pageTitle = ref(props.page?.title ?? "");
const sortedFields = computed(() =>
  [...(props.page?.fields ?? [])].sort((firstField, secondField) => (firstField.order ?? 0) - (secondField.order ?? 0)),
);

const getChecklists = async () => {
  try {
    console.log("getChecklists");
  } catch (err) {
    await handleError(err);
  }
};

const addField = () => {
  emit("add-field");
};

const changePageValue = val => {
  pageTitle.value = val?.value ?? "";
  emit("change-page", pageTitle.value);
};

const changeFieldValue = (fieldUid, val) => {
  emit("change-field", { fieldUid, value: val });
};

const getFieldErrors = fieldUid => props.errors?.fields?.[fieldUid] ?? {};

const getFieldAnchorId = fieldOrder => `checklist-page-${props.pageOrder}-field-${fieldOrder}`;

onMounted(() => {
  if (sortedFields.value.length === 0) {
    addField();
  }
});
</script>

<style scoped lang="scss">
.checklist-form-pages-item {
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--checklist-section-border);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  &__number {
    font-size: 20px;
    font-weight: 700;
    color: var(--modal-form-card-color);
    line-height: 1.2;
  }

  &__title {
    margin-top: 12px;
    margin-bottom: 24px;
    color: var(--modal-form-card-color);
  }

  &__title-field {
    position: relative;

    :deep(.form-field-label) {
      font-size: 18px;
      font-weight: 600;
    }
  }

  &__fields {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__add-field-button {
    width: 100%;
    margin-top: 12px;
    padding: 12px 14px;
    border: 1px dashed var(--checklist-section-border);
    border-radius: 12px;
    background: transparent;
    color: var(--modal-form-card-color);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;

    &:hover {
      opacity: 0.75;
    }
  }
}
</style>
